/**
 * © [2023] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */
import * as ActionTypes from './actionTypes';

const initialState = {
  planType: [],
  rebateProgramList: [],
  rebateProgramNameValue: '',
  selectedPlanType: '',
  rebateProgramValue: '',
  errors: [],
  rebateProgramName: '',
  searchResult: [],
  manufacturerList: [],
  isLoading: false,
  ndcPaymentMaxQuarter: '',
  quarter: '',
  quarterValue: '',
  searchScreenVar: {
    rebateProgrameName: '',
    rebateProgramValue: '',
    selectedPlanType: '',
    quarterValue: '',
  },
};

export const reducer = (state = initialState, action) => {
  switch (action.type) {
    case ActionTypes.GET_PLAN_TYPE_DATA:
      return { ...state, planType: action.payload };
    // case ActionTypes.GET_REBATE_PROGRAM_UNALLOACTED_BALANCE:
    //   return { ...state, rebateProgramList: action.payload };
    case ActionTypes.SET_SELECTED_INPUT_NDC_PAYMENT:
      return { ...state, ...action.payload };
    case ActionTypes.GET_NDC_PAYMENTS_MAX_QUARTER:
      return {
        ...state,
        ndcPaymentMaxQuarter: action.ndcPaymentMaxQuarter,
      };
    //For Result Grid
    case ActionTypes.GET_NDC_PAYMENT_RESULT_GRID:
      return { ...state, searchResult: action.searchResult };
    case ActionTypes.IS_LOADING_NDC_PAYMENT:
      return { ...state, isLoading: action.isLoading };
    case ActionTypes.REFRESH_NDC_PAYMENT:
      return { ...state, searchScreenVar: initialState.searchScreenVar };
    case ActionTypes.REFRESH_NDC_PAYMENT_DISPLAY:
      return { ...state, searchScreenVar: initialState.searchScreenVar };

    default:
      return state;
  }
};

export default reducer;
